import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=365d92d2&scoped=true&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AccordionItem.vue?vue&type=style&index=0&id=365d92d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d92d2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/AccordionItem.vue
// module id = 196
// module chunks = 0